import { Stack, Button, SelectChangeEvent } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import FilterDatePicker from 'src/components/filter-form/filter-date-picker';
import FilterSingleSelect from 'src/components/filter-form/filter-single-select';
import { PositionFilters, PositionFilterKey, PositionFilterValue } from 'src/type/position';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import Iconify from 'src/components/iconify';
import { PositionTypeOptions } from './utils';

type Props = {
  filters: PositionFilters;
  onFilters: (name: PositionFilterKey, value: PositionFilterValue) => void;
  dateError: boolean;
  disabledSearch?: boolean;
  enableCreate?: boolean;
  onCreatePosition?: VoidFunction;
};

export default function PositionTableToolbar({
  filters,
  onFilters,
  dateError,
  disabledSearch,
  enableCreate,
  onCreatePosition,
}: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterType = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('type', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        width: 1,
      }}
    >
      <FilterSingleSelect
        label="ประเภท"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.type}
        onChange={handleFilterType}
        options={PositionTypeOptions}
      />

      <FilterDatePicker
        label="จากวันที่"
        value={filters.startDate}
        onChange={handleFilterStartDate}
      />
      <FilterDatePicker
        label="ถึงวันที่"
        value={filters.endDate}
        onChange={handleFilterEndDate}
        dateError={dateError}
      />

      {enableCreate && (
        <Stack
          direction="row"
          spacing={2}
          sx={{ ml: { md: 'auto' } }}
          alignItems="center"
          width={{ xs: 1, md: 'auto' }}
        >
          <Button
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={onCreatePosition}
            sx={{ width: { xs: 1, md: 200 } }}
          >
            สร้างรายการตัดซื้อ/ขาย
          </Button>
        </Stack>
      )}

      {!disabledSearch && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          flexGrow={1}
          sx={{ width: { xs: 1, md: 'auto' } }}
        >
          <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
        </Stack>
      )}
    </Stack>
  );
}
